import { jsx } from "panel";
import { ModalEl, ModalType } from "common/components/modal";
import { TrackedUserIconEl } from "common/widgets/tracked-user-icon";
import { renameEvent } from "common/report/util/events";
import { ExpandedRowEl } from "common/report/events/expanded-row/index";
import { PropertyKeyFilter } from "common/report/events/types";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerSize } from "common/components/spinner/types";
import { InputEl } from "common/components/input";
import { InputSize } from "common/components/input/types";
import { SvgIconEl } from "common/components/svg-icon";
import { ServerErrorHero } from "common/widgets/warning-hero/presets";
import { renderCellProperty } from "common/report/events/table-cell-mixins";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { ButtonEl } from "common/components/button";
import { IconSizeType } from "common/constants";
import { isGlobalSidenavEnabled } from "iron/routes/global-sidenav/utils";
import { WarningHeroReportName } from "../warning-hero/constants";
import { NoDataHeroPanel } from "../warning-hero/no-data-hero";
export function template() {
  const handleSelect = (idx) => {
    this.helpers.handleSelect(idx);
  };
  const closeSidebar = () => {
    this.dispatchEvent(new CustomEvent("close"));
  };
  let contents;
  if (this.state.selectedEvent) {
    const event = this.state.selectedEvent;
    contents = /* @__PURE__ */ jsx(null, null, sidebarHeaderDetails(this.state.url, this.helpers.handleUnselect.bind(this), closeSidebar), /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-content-container" }, /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-event-expanded" }, /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-event-expanded-header" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".events-sidebar-event-page-control", on: {
      click: () => this.helpers.handleSelect(this.state.selectedRowIdx - 1)
    }, class: {
      "events-sidebar-event-page-control-disabled": this.state.selectedRowIdx === 0
    }, attrs: {
      theme: ButtonTheme.Tertiary,
      title: "Previous event (viewing ".concat(this.state.selectedRowIdx + 1, " of ").concat(this.state.events.length, ")")
    } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "arrow-left"
    } })), /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-event-details" }, /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-event-detail-name" }, /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-event-detail-name-label" }, renameEvent(event.event), " ")), /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-event-detail-subproperty" }, renderCellProperty(event, "time", this.getContext("i18n")))), /* @__PURE__ */ jsx(ButtonEl, { sel: ".events-sidebar-event-page-control", on: {
      click: () => this.helpers.handleSelect(this.state.selectedRowIdx + 1)
    }, class: {
      "events-sidebar-event-page-control-disabled": this.state.selectedRowIdx + 1 >= this.state.events.length
    }, attrs: {
      theme: ButtonTheme.Tertiary,
      title: "Next event (viewing ".concat(this.state.selectedRowIdx + 1, " of ").concat(this.state.events.length, ")")
    } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "arrow-right"
    } }))), /* @__PURE__ */ jsx(ExpandedRowEl, { props: {
      pinnedProperties: this.state.pinnedProperties,
      row: event
    }, attrs: {
      toggletheme: "tab-bar",
      "allow-pinning": true,
      "view-format": this.state.viewFormat,
      "property-key-filter": this.state.propertyKeyFilter,
      toggleoptions: [{
        value: PropertyKeyFilter.AllProperties,
        label: "All Properties"
      }, {
        value: PropertyKeyFilter.YourProperties,
        label: "Project"
      }, {
        value: PropertyKeyFilter.MixpanelProperties,
        label: "Mixpanel"
      }]
    }, on: {
      propertyKeyFilterChange: (ev) => {
        this.update({
          propertyKeyFilter: ev.detail.propertyKeyFilter
        });
      },
      pinsupdated: (ev) => {
        const {
          pins
        } = ev.detail;
        this.update({
          pinnedProperties: pins
        });
      }
    } }))));
  } else if (this.state.loading) {
    contents = /* @__PURE__ */ jsx(null, null, sidebarHeader(this.state.url, closeSidebar), /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-content-container" }, /* @__PURE__ */ jsx(InputEl, { sel: ".events-sidebar-search-input", attrs: {
      icon: "search",
      placeholder: "Search\u2026",
      size: InputSize.Medium,
      "show-clear": true
    }, props: {
      maxLength: 50,
      value: this.state.search
    } }), /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-loading" }, /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
      size: SpinnerSize.Large
    } }))));
  } else if (this.state.error) {
    contents = /* @__PURE__ */ jsx(ServerErrorHero, { reportName: WarningHeroReportName.EventsSidebar });
  } else if (this.state.events.length === 0) {
    contents = /* @__PURE__ */ jsx(NoDataHeroPanel, { reportName: WarningHeroReportName.EventsSidebar });
  } else {
    contents = /* @__PURE__ */ jsx(null, null, sidebarHeader(this.state.url, closeSidebar), /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-content-container.events-sidebar-content-list" }, /* @__PURE__ */ jsx(InputEl, { sel: ".events-sidebar-search-input", attrs: {
      icon: "search",
      placeholder: "Search\u2026",
      size: InputSize.Medium,
      "show-clear": true
    }, on: {
      clear: () => this.helpers.onSearchChange(""),
      input: (ev) => this.helpers.onSearchChange(ev.target.value)
    }, props: {
      maxLength: 50,
      value: this.state.search
    } }), /* @__PURE__ */ jsx("ul", { sel: ".events-sidebar-events" }, this.state.events.map((event, idx) => {
      return /* @__PURE__ */ jsx("li", { sel: ".events-sidebar-event", on: {
        click() {
          handleSelect(idx);
        }
      } }, /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-icon-wrapper" }, /* @__PURE__ */ jsx(TrackedUserIconEl, { attrs: {
        "distinct-id": event.properties.distinct_id,
        email: event.properties.email,
        size: IconSizeType.Small
      } })), /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-event-detail" }, /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-event-detail-name" }, renameEvent(event.event)), /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-event-detail-subproperty" }, renderCellProperty(event, "time", this.getContext("i18n")))));
    }))));
  }
  return /* @__PURE__ */ jsx(ModalEl, { attrs: {
    "modal-type": ModalType.RightDrawer,
    open: true,
    closeable: true,
    "hide-backdrop": true,
    "global-sidenav-enabled": isGlobalSidenavEnabled(this.getCurrentProject())
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-wrapper", class: {
    "events-sidebar-global-sidenav-enabled": isGlobalSidenavEnabled(this.getCurrentProject())
  } }, contents));
}
function sidebarHeader(fullPageUrl, closeSidebar) {
  return /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-header", "data-sentry-component": "sidebarHeader", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("h2", null, "Events"), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Tertiary,
    size: ButtonSize.Small,
    href: fullPageUrl
  }, on: {
    click: closeSidebar
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Open as page"));
}
function sidebarHeaderDetails(fullPageUrl, unselect, closeSidebar) {
  return /* @__PURE__ */ jsx("div", { sel: ".events-sidebar-header", "data-sentry-component": "sidebarHeaderDetails", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Tertiary,
    size: ButtonSize.Small
  }, on: {
    click: unselect
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "\u2190"), /* @__PURE__ */ jsx("h2", null, "Event Detail"), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Tertiary,
    size: ButtonSize.Small,
    href: fullPageUrl
  }, on: {
    click: closeSidebar
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Open as page"));
}
